<template>
  <BuilderWrapper
    title="Legend"
    helpful-tip="The legend settings determine the colour that each geometry will be filled, based upon the total project value in that area"
  >
    <b-input-group
      v-for="(legend, index) in legends"
      :key="index"
      class="d-flex align-items-center"
    >
      <b-col
        cols="5"
        class="p-0"
      >
        <ColorPicker
          v-model="legend.colour"
          :debounce="500"
        />
      </b-col>
      <b-col
        cols="6"
        class="p-0"
      >
        <b-input
          v-model="legend.range"
          required
          type="number"
          :state="validate(index)"
          data-cy="axis-value-input"
        />
      </b-col>
      <b-col
        cols="1"
        class="p-0"
        align-self="center"
      >
        <b-button
          v-if="index > 0 && index < legends.length-1"
          class="font-weight-bold square"
          variant="outline-danger"
          size="sm"
          @click="minusLegendValue(index)"
        >
          &#x2212;
        </b-button>
        <b-button
          v-else-if="index === legends.length-1"
          class="font-weight-bold square"
          variant="info"
          size="sm"
          @click="addLegendValue"
        >
          &#x2b;
        </b-button>
      </b-col>
    </b-input-group>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { ColorPicker } from '@orbica/vue-modules'
import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
// @ts-ignore vuex-map-fields import
import { mapMultiRowFields } from 'vuex-map-fields'

import {
  // FieldMapItem,
  // FieldCalculationV2Config,
  MapLegendItem,
} from '@/types'

const components = {
  BuilderWrapper,
  ColorPicker,
}

@Component({
  components,
  computed: {
    ...mapMultiRowFields('primaryApp', {
      legends: 'appState.config.mapConfig.legends',
      // fieldMap: 'config.fieldMap',
    }),
  },
})
export default class MapLegendsConfig extends Vue {
  legends!: MapLegendItem[]
  // Deprecated codes??? for some reason these are not used
  // fieldMap!: (FieldMapItem | FieldCalculationV2Config)[]

  // get totaldata () {
  //   const nestedobjects = this.$typedStore.public.geometries.locationData
  //   return Object.values(nestedobjects).map((obj) => { return this.total(obj) })
  // }

  // get min () {
  //   return this.totaldata.reduce((min, p) => p < min ? p : min, this.totaldata[0])
  // }

  // get max () {
  //   return this.totaldata.reduce((max, p) => p > max ? p : max, this.totaldata[0])
  // }

  // total (object) {
  //   return this.fieldMap.reduce((total, current) => current.total ? total + Number(object[current.column]) : total, 0)
  // }

  validate (index: number) {
    if (index === this.legends.length - 1) return null
    return Number(this.legends[index].range) < Number(this.legends[index + 1].range) ? null : false
  }

  addLegendValue () {
    this.$typedStore.visualisationApp.addLegendValue()
  }

  minusLegendValue (index: number) {
    this.$typedStore.visualisationApp.minusLegendValue(index)
  }
}

</script>

<style scoped>
.square {
  width: 2rem;
  height: 2rem;
}
</style>
